import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-no-wallet',
  templateUrl: './no-wallet.component.html',
  styleUrl: './no-wallet.component.scss',
})

export class NoWalletComponent {
  presale_singular_link: string = environment.presale_singular_link;

  constructor(public modalRef: BsModalRef, private analyticsService: AnalyticsService) {}

  handleSingularLinkClick(): void {
    this.analyticsService.vwoData('singular', { downloadBestwalletPlacement: "Don't have wallet" });
  }
}
